import { Component, inject } from '@angular/core';
import { BrochureService } from '../../services/brochure.service';

@Component({
  selector: 'app-wilderness-invite',
  standalone: true,
  imports: [],
  templateUrl: './wilderness-invite.html',
  styleUrl: './wilderness-invite.css'
})
export class WildernessInviteComponent {
  private brochureService = inject(BrochureService);

  spotlightX = '50%';
  spotlightY = '50%';
  spotlightOpacity = 0;

  updateSpotlight(event: PointerEvent) {
    const section = event.currentTarget as HTMLElement | null;
    if (!section) return;
    const rect = section.getBoundingClientRect();
    this.spotlightX = `${((event.clientX - rect.left) / rect.width) * 100}%`;
    this.spotlightY = `${((event.clientY - rect.top) / rect.height) * 100}%`;
    this.spotlightOpacity = 1;
  }

  activateSpotlight() { this.spotlightOpacity = 1; }

  resetSpotlight() {
    this.spotlightX = '50%';
    this.spotlightY = '50%';
    this.spotlightOpacity = 0;
  }

  openBrochureModal() { this.brochureService.open(); }
}
